// inv/src/pages/authentication/ResetPasswordPage.jsx
import { useState } from 'react';
import { API_URL } from '../../config';
import axios from 'axios';
import { Input } from "../../components/ui/input";
import { useSearchParams, Link } from 'react-router-dom';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [passwordResetSuccess, setPasswordResetSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    console.log('Reset password form submitted!');

    const passwordToSend = newPassword.trim();
    const confirmPasswordToCheck = confirmPassword.trim();

    console.log('Password to send:', passwordToSend ? '***' : 'empty');
    console.log('Confirm password:', confirmPasswordToCheck ? '***' : 'empty');

    if (passwordToSend !== confirmPasswordToCheck) {
      setMessage('Passwords do not match.');
      console.log('Passwords do not match');
      return;
    }

    if (!passwordToSend || passwordToSend.length < 6) {
      setMessage('Password must be at least 6 characters long.');
      console.log('Password too short');
      return;
    }

    console.log('Setting loading state...');
    setIsLoading(true);

    try {
      console.log('Sending request to reset password with token:', token);
      const response = await axios.post(`${API_URL}/reset-password`, {
        token: token,
        password: passwordToSend,
      }, { withCredentials: true });

      console.log('Response from server:', response.data);
      setMessage(response.data.message);
      setPasswordResetSuccess(true);
    } catch (error) {
      console.error('Error resetting password:', error);
      console.log('Error response from server:', error.response ? error.response.data : 'No response data');

      if (error.response?.data?.message?.includes('already been used')) {
        setMessage('This password reset link has already been used. Please request a new password reset link.');
      } else {
        setMessage(error.response?.data?.message || 'Error resetting password.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center">
      <div className="w-full max-w-md bg-white rounded-lg shadow sm:max-w-md xl:p-0">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h2 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl  text-left">
            Reset Password
          </h2>
          <form className="space-y-4 md:space-y-6" onSubmit={handleResetPassword}>
            <div>
              <label htmlFor="new-password" className="block mb-2 text-sm font-medium text-gray-900 ">
                New password
              </label>
              <Input
                type="password"
                id="new-password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                required
                disabled={isLoading}
                multi={false}
              />
              <div className="mt-1">
                <p className="text-xs text-gray-500">
                  * Password must be at least 6 characters long
                </p>
              </div>
            </div>
            <div>
              <label htmlFor="confirm-password" className="block mb-2 text-sm font-medium text-gray-900 ">
                Confirm password
              </label>
              <Input
                type="password"
                id="confirm-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm password"
                required
                disabled={isLoading}
                multi={false}
              />
            </div>
            <button
              type="submit"
              disabled={isLoading}
              onClick={() => console.log('Reset password button clicked!')}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-stone-900 rounded-lg hover:bg-stone-800 focus:ring-4 focus:outline-none focus:ring-stone-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
          {message && (
            <p className={`text-center ${passwordResetSuccess ? 'text-green-500' : 'text-red-500'}`}>
              {message}
            </p>
          )}

          {passwordResetSuccess && (
            <div className="text-center mt-4">
              <p>Now you can <Link to="/login" className="text-blue-500 hover:underline">login to your account</Link>.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;